var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from "react";
import { Snackbar, Box, Paper, makeStyles, Slide, useMediaQuery, } from "@material-ui/core";
import clsx from "clsx";
import ErrorIcon from "../icons/Error";
import SuccessIcon from "../icons/Success";
import CloseIcon from "../icons/Close";
import FTLTypography from "./FTLTypography";
function SlideTransition(props) {
    return React.createElement(Slide, Object.assign({}, props, { direction: "up" }));
}
export default (_a) => {
    var { open, message, hideDuration = 3000, onClose, IconComponent, variant, className } = _a, otherProps = __rest(_a, ["open", "message", "hideDuration", "onClose", "IconComponent", "variant", "className"]);
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(open);
    const mobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
    useEffect(() => {
        setIsOpen(open);
    }, [open]);
    return (React.createElement(Snackbar, Object.assign({ open: isOpen, autoHideDuration: hideDuration, className: clsx(className, classes.root), onClose: () => {
            setIsOpen(false);
            if (onClose) {
                onClose();
            }
        }, TransitionComponent: mobile ? SlideTransition : undefined, anchorOrigin: {
            horizontal: "center",
            vertical: "bottom",
        } }, otherProps),
        React.createElement(Box, { className: classes.body, component: Paper },
            React.createElement(Box, { display: "flex" },
                variant === "error" ? (React.createElement(ErrorIcon, { className: classes.icon })) : variant === "success" ? (React.createElement(SuccessIcon, { className: classes.icon })) : (IconComponent && React.createElement(IconComponent, { className: classes.icon })),
                React.createElement(FTLTypography, { variant: "p3", style: {
                        padding: "2px 0",
                    } }, message)),
            React.createElement(CloseIcon, { className: classes.closeIcon, color: "secondary", sizeRatio: 1.25, onClick: () => {
                    setIsOpen(false);
                    if (onClose) {
                        onClose();
                    }
                } }))));
};
const useStyles = makeStyles((theme) => ({
    root: {
        bottom: 40,
        [theme.breakpoints.down("sm")]: {
            bottom: 0,
            left: 0,
            right: 0,
        },
    },
    icon: {
        marginRight: 14,
    },
    body: {
        position: "relative",
        padding: "8px 10px",
        display: "flex",
        justifyContent: "space-between",
        minWidth: 245,
        boxShadow: "0px 16px 16px rgba(0, 0, 0, 0.12), 0px 0px 8px rgba(0, 0, 0, 0.08)",
        [theme.breakpoints.down("sm")]: {
            bottom: 0,
            width: "100%",
            padding: "12px 16px",
        },
    },
    closeIcon: {
        cursor: "pointer",
        margin: 2,
        marginLeft: 14,
    },
}));
//# sourceMappingURL=FTLSnackbar.js.map